import { render, staticRenderFns } from "./AlgoliaInput.vue?vue&type=template&id=6bcba344&"
import script from "./AlgoliaInput.vue?vue&type=script&lang=js&"
export * from "./AlgoliaInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports